// import Vue from 'vue'
// import Vuex from 'vuex'
// import getters from './getters'
// import app from './modules/app'
//
// Vue.use(Vuex)
//
// const store = new Vuex.Store({
//   modules: {
//     app
//   },
//   getters
// })
//
// export default store

import { createStore } from 'vuex'
import getters from './getters'
import app from './modules/app.js'
import routerCache from './modules/routerCache.js'
export default createStore({
    modules: {
        app,
        routerCache
    },
    getters
})
